import { Box } from "@mui/material";
import { styled } from '@mui/material/styles'

export const EventMetricsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  columnGap: "24px",
  justifyContent: "space-between"
}));